// Static presentation metadata for the encounter fields table and picker.
// Field keys mirror the canonical schema in
// common/lib/model/documentScan/encounterEntityMappingSchema.ts.

export interface EncounterFieldCategory {
    key: string;
    label: string;
}

export const ENCOUNTER_FIELD_CATEGORIES: EncounterFieldCategory[] = [
    { key: 'patientIdentity', label: 'Patient identity' },
    { key: 'patientContact', label: 'Patient contact' },
    { key: 'patientDemographics', label: 'Patient demographics' },
    { key: 'encounterDetails', label: 'Encounter details' },
    { key: 'accident', label: 'Accident' },
    { key: 'groups', label: 'Groups' },
];

const fieldCategoriesByKey: Record<string, string> = {
    patMrn: 'patientIdentity',
    patLastNm: 'patientIdentity',
    patFrstNm: 'patientIdentity',
    patMidNm: 'patientIdentity',
    patSsn: 'patientIdentity',
    patDob: 'patientIdentity',
    patGenderCd: 'patientIdentity',
    patDrLicNo: 'patientIdentity',
    patDrLicSt: 'patientIdentity',
    patDrLicExp: 'patientIdentity',

    patAddrLn1: 'patientContact',
    patAddrLn2: 'patientContact',
    patCity: 'patientContact',
    patStateCd: 'patientContact',
    patZipCd: 'patientContact',
    patCntryCd: 'patientContact',
    patPhNoHome: 'patientContact',
    patPhNoBus: 'patientContact',
    patPhNoMob: 'patientContact',
    patEmailHome: 'patientContact',
    patEmailBus: 'patientContact',

    patOccup: 'patientDemographics',
    patPrimLang: 'patientDemographics',
    patMaritalStatus: 'patientDemographics',
    patReligion: 'patientDemographics',
    patRace: 'patientDemographics',
    patEthnicGrp: 'patientDemographics',
    patNationality: 'patientDemographics',
    patDeceasedInd: 'patientDemographics',
    patDeceasedDt: 'patientDemographics',

    enctrNo: 'encounterDetails',
    admitDt: 'encounterDetails',
    admitTm: 'encounterDetails',
    dischDt: 'encounterDetails',
    dischTm: 'encounterDetails',
    purgedInd: 'encounterDetails',
    purgedDttm: 'encounterDetails',
    enctrAdmitTyp: 'encounterDetails',
    enctrPatClass: 'encounterDetails',
    enctrPatTyp: 'encounterDetails',
    enctrHospSvcCd: 'encounterDetails',

    accDt: 'accident',
    accCd: 'accident',
    accDesc: 'accident',
    accLocn: 'accident',
    accAutoStCd: 'accident',
    accAutoStNm: 'accident',
    accJobRelInd: 'accident',
    accDeathInd: 'accident',

    enctrInsuranceDoc: 'groups',
    enctrDiagnosisDoc: 'groups',
    enctrRelationsDoc: 'groups',
    enctrGuarantorDoc: 'groups',
};

export function getEncounterFieldCategory(fieldKey: string): string {
    return fieldCategoriesByKey[fieldKey] || 'encounterDetails';
}
